import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import { GET_CATEGORY_PAGE } from '@/graphql/queries';
import addDerivedProductData from 'hooks/useProductListingData/helpers/addDerivedProductData';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const SingleCollectionCards = t0 => {
  const $ = _c(34);
  const {
    slug: t1,
    skipProductIds: t2,
    productsList: t3,
    col: t4,
    modifier: t5,
    limit: t6
  } = t0;
  const slug = t1 === undefined ? "" : t1;
  let t7;
  if ($[0] !== t2) {
    t7 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const skipProductIds = t7;
  const productsList = t3 === undefined ? null : t3;
  const col = t4 === undefined ? 4 : t4;
  const modifier = t5 === undefined ? "" : t5;
  const limit = t6 === undefined ? 4 : t6;
  const userLocation = useUserLocation();
  const t8 = limit + skipProductIds.length;
  const t9 = userLocation?.stateShortName;
  let t10;
  if ($[2] !== t9) {
    t10 = getVisitorLocationQueryVariables(t9);
    $[2] = t9;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== slug || $[5] !== t10 || $[6] !== t8) {
    t11 = {
      variables: {
        slug,
        limit: t8,
        ...t10
      }
    };
    $[4] = slug;
    $[5] = t10;
    $[6] = t8;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const {
    data: categoryData,
    loading: categoryPageDataLoading,
    error: categoryPageDataError
  } = useSuspenseQuery(GET_CATEGORY_PAGE, t11);
  categoryData?.getCategoryPage?.products;
  categoryData?.getCategoryPage?.upholsteryOptions;
  let t12;
  bb0: {
    if (productsList) {
      let t13;
      if ($[8] !== productsList) {
        t13 = productsList.map(_temp2);
        $[8] = productsList;
        $[9] = t13;
      } else {
        t13 = $[9];
      }
      t12 = t13;
      break bb0;
    }
    if (!categoryData?.getCategoryPage?.products) {
      let t13;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = [];
        $[10] = t13;
      } else {
        t13 = $[10];
      }
      t12 = t13;
      break bb0;
    }
    let t13;
    if ($[11] !== categoryData?.getCategoryPage?.products || $[12] !== categoryData?.getCategoryPage?.upholsteryOptions || $[13] !== limit || $[14] !== skipProductIds) {
      t13 = categoryData?.getCategoryPage?.products.filter(product_0 => !skipProductIds.includes(product_0.id)).map(product_1 => {
        const productWithData = addDerivedProductData({
          product: product_1,
          upholsteryOptions: categoryData?.getCategoryPage?.upholsteryOptions
        });
        return {
          ...productWithData,
          variantsToShow: productWithData.variants.filter(_temp3)
        };
      }).slice(0, limit);
      $[11] = categoryData?.getCategoryPage?.products;
      $[12] = categoryData?.getCategoryPage?.upholsteryOptions;
      $[13] = limit;
      $[14] = skipProductIds;
      $[15] = t13;
    } else {
      t13 = $[15];
    }
    t12 = t13;
  }
  const categoryProducts = t12;
  if (!categoryProducts.length && categoryPageDataLoading) {
    let t13;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="w-full flex flex-col items-center justify-center"><ProgressLoader /></div>;
      $[16] = t13;
    } else {
      t13 = $[16];
    }
    return t13;
  }
  if (!categoryProducts.length && (!categoryPageDataLoading || categoryPageDataError)) {
    return null;
  }
  const t13 = modifier === "modular";
  let t14;
  if ($[17] !== t13) {
    t14 = classNames({
      "max-[767px]:flex max-[767px]:min-h-[225px] max-[767px]:mt-2": t13
    });
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = col === 1;
  const t16 = col === 4;
  const t17 = modifier === "modular";
  let t18;
  if ($[19] !== t15 || $[20] !== t16 || $[21] !== t17) {
    t18 = classNames("grid grid-cols-[repeat(auto-fit,minmax(100%,1fr))] gap-[10px]", {
      "md:m-2 md:grid-cols-[repeat(auto-fit,minmax(300px,100%))]": t15,
      "md:m-2 md:grid-cols-[repeat(auto-fit,minmax(300px,calc(50%_-_5px)))] lg:grid-cols-[repeat(auto-fit,minmax(300px,calc(33%_-_7px)))] min-[1400px]:grid-cols-[repeat(auto-fit,minmax(300px,calc(25%_-_10px)))]": t16,
      "max-[767px]:!flex max-[767px]:!flex-row max-[767px]:!flex-nowrap max-[767px]:!overflow-x-scroll": t17
    });
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== categoryProducts || $[24] !== modifier) {
    let t20;
    if ($[26] !== modifier) {
      t20 = product_2 => <div key={product_2.slug} className={classNames({
        "max-[767px]:!flex-shrink-0 max-[767px]:!mr-2 max-[767px]:!max-w-[500px] max-[767px]:!w-4/5": modifier === "modular"
      })}><ProductCardStatic filterStateKey="no-filters--featured" isClearance={product_2.isClearance} label={product_2.label} moreVariantsCount={product_2.moreVariantsCount} name={product_2.name} onDisplayInShowroomSlug={product_2.onDisplayInShowroomSlug} path={product_2.path} position={product_2.position} productFamily={product_2.productFamily} productLabel={product_2.productLabel} productType={product_2.productType} quickship={product_2.quickship} secondaryImageCropData={product_2.secondaryImageCropData} slug={product_2.slug} variants={product_2.variants} variantsToShow={product_2.variantsToShow} variantsTotal={product_2.variantsTotal} enableMobileCarousel={true} campaign={product_2.campaign} id={product_2.id} layout="full" secondaryImage={product_2.secondaryImage} /></div>;
      $[26] = modifier;
      $[27] = t20;
    } else {
      t20 = $[27];
    }
    t19 = categoryProducts.map(t20);
    $[23] = categoryProducts;
    $[24] = modifier;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[28] !== t18 || $[29] !== t19) {
    t20 = <div className={t18}>{t19}</div>;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t14 || $[32] !== t20) {
    t21 = <div className={t14}>{t20}</div>;
    $[31] = t14;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  return t21;
};
SingleCollectionCards.propTypes = {
  slug: PropTypes.string,
  skipProductIds: PropTypes.arrayOf(PropTypes.number),
  productsList: PropTypes.arrayOf(PropTypes.object),
  col: PropTypes.number,
  modifier: PropTypes.string,
  limit: PropTypes.number
};
export default SingleCollectionCards;
function _temp(_, index) {
  return index < 6;
}
function _temp2(product) {
  return {
    ...product,
    variantsToShow: product.variants.filter(_temp)
  };
}
function _temp3(__0, index_0) {
  return index_0 < 6;
}